import { gql } from '@apollo/client';

export const getVatValues = gql`
  query GetVatValues {
    vatValues {
      dutchVat
    }
  }
`;

export default getVatValues;
